<template>
  <!-- Decorative: the adjacent KPI value/delta text already conveys the data -->
  <div v-if="hasData" :style="{ height: height + 'px' }" aria-hidden="true">
    <Line :data="chartData" :options="options" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
} from 'chart.js'

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Filler)

export default {
  name: 'Sparkline',
  components: { Line },
  props: {
    // Array of numbers. Renders nothing unless there are >= 2 real points
    // (so it degrades gracefully when the API hasn't been deployed with trend data).
    data: { type: Array, default: () => [] },
    color: { type: String, default: '#6B8E23' }, // hex only (gradient trick appends alpha)
    height: { type: Number, default: 36 },
  },
  setup(props) {
    const hasData = computed(
      () => Array.isArray(props.data) && props.data.filter((v) => v != null).length >= 2
    )

    const chartData = computed(() => ({
      labels: props.data.map((_, i) => i),
      datasets: [
        {
          data: props.data,
          borderColor: props.color,
          borderWidth: 2,
          fill: true,
          backgroundColor: (ctx) => {
            const chart = ctx.chart
            const { ctx: c, chartArea } = chart
            if (!chartArea) return 'transparent'
            const g = c.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
            g.addColorStop(0, props.color + '33')
            g.addColorStop(1, props.color + '00')
            return g
          },
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 0,
        },
      ],
    }))

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: false }, tooltip: { enabled: false } },
      scales: { x: { display: false }, y: { display: false } },
      elements: { line: { borderCapStyle: 'round' } },
      animation: false,
    }

    return { hasData, chartData, options }
  },
}
</script>
